require('./retailLoanCatalogModal.scss');
require('./retailLoanCatalogModal.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { withRouter } = require("react-router-dom");
//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKModal = require('components/commons/OKModal/OKModal');
//@components
const { RetailLoanImageGalleryContainer } = require('../retailLoanImageGalleryContainer/retailLoanImageGalleryContainer');
const { RetailDeliveryInfoBox } = require('../retailDeliveryInfoBox/retailDeliveryInfoBox');
const { ContractLoanPdfViewer } = require('../../contractLoanPdfViewer/contractLoanPdfViewer');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const {
    recordLinkV2,
} = require('utilities/tagging');
//@helpers
const { isRetailAddressDelivery, buildEventsModal } = require('../../../../loansUtilities/loansHelper');
//@constants
const {
    retailLoanCommons: { MODAL_VIEWER_HEIGHT },
    retailLoanGallery: { MAIN_IMAGE_WIDTH_CATALOG_MODAL },
    retailLoanDoTaggin: {
        LOAD_MODAL_TERMS_CONDITIONS,
        NAME_PAGE_SPECIFICATIONS_VIEW,
        TAGGING_TERMS_AND_CONDITIONS,
        TAGGING_VIEW, TAGGING_CONTINUE,
        TAGGING_EXIT,
        TAGGING_CLOSE,
        TAGGING_PRINT,
        TAGGING_DOWNLOAD,
    }
} = require('../../../../loansConstants/index');

class RetailLoanCatalogModalComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            viewerHeight: 'auto'
        }

        this.getSize = this.getSize.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleSetAgree = this.handleSetAgree.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { getTermConditionDocuments, item, showModal } = this.props;

        if (prevProps.showModal !== showModal && showModal && getTermConditionDocuments) {
            getTermConditionDocuments(item);
            const customData = buildEventsModal(LOAD_MODAL_TERMS_CONDITIONS, TAGGING_VIEW, NAME_PAGE_SPECIFICATIONS_VIEW);
            recordLinkV2(customData);
        }
    }

    handleOnPrintDocument() {
        const { onPrintDocument } = this.props;
        const customData = buildEventsModal(LOAD_MODAL_TERMS_CONDITIONS, TAGGING_PRINT, NAME_PAGE_SPECIFICATIONS_VIEW);
        recordLinkV2(customData);
        onPrintDocument();
    }

    handleOnDownloadDocument() {
        const { onDownloadDocumentTermCondition } = this.props;
        const customData = buildEventsModal(LOAD_MODAL_TERMS_CONDITIONS, TAGGING_DOWNLOAD, NAME_PAGE_SPECIFICATIONS_VIEW);
        recordLinkV2(customData);
        onDownloadDocumentTermCondition();
    }

    handleSetAgree() {
        const { immRetailLoan, setAgree } = this.props;
        if (!immRetailLoan.get('agree')) {
            const customData = buildEventsModal(LOAD_MODAL_TERMS_CONDITIONS, TAGGING_TERMS_AND_CONDITIONS, NAME_PAGE_SPECIFICATIONS_VIEW);
            recordLinkV2(customData);
        }
        setAgree();
    }

    buildModalContentFooter() {
        let modalContentFooter;
        const { immRetailLoan } = this.props;
        const agreeCheckbox = immRetailLoan.get('agree');
        const label = (
            <React.Fragment>
                <FormattedText value="retailLoanCatalog-retailLoanCatalog_checkBoxAccept" />
                <FormattedText
                    value="retailLoanCatalog-retailLoanCatalog_termsAndConditions"
                    className="retail-loan-catalog-modal__terms-and-conditions"
                />
            </React.Fragment>
        );
        const errorState = immRetailLoan.get('agreeError') && !agreeCheckbox;
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const className = classNames('retail-loan-catalog-modal__checkbox-modal', {
            'retail-loan-catalog-modal__checkbox-modal--with-error': errorState,
        });

        if (!immRetailLoan.get('errorDocumentsTermConditions')) {
            modalContentFooter = (
                <div className={className}>
                    <OKCheckbox
                        disabled={immRetailLoan.get('isFetchingDocumentsTermConditions')}
                        errorMessage={errorMessage}
                        errorState={errorState}
                        idName="retail-loan-catalog-modal-checkbox"
                        label={label}
                        onChange={this.handleSetAgree}
                        value={agreeCheckbox}
                    />
                </div>
            );
        }

        return modalContentFooter;
    }

    buildTitle() {
        return (
            <div className="retail-loan-catalog-modal__title" >
                <FormattedText value="retailLoanCommon-termAndConditionsTitle" />
            </div>
        );
    }

    buildPdfViewer() {
        const {
            getTermConditionDocuments,
            immRetailLoan,
            labels,
            onHandleToggleModal,
            showModal,
        } = this.props;
        const { viewerHeight } = this.state;
        const title = this.buildTitle();
        const modalContentFooter = this.buildModalContentFooter();
        const documentsTermConditions = immRetailLoan.get('documentsTermConditions');
        const validate = immRetailLoan.get('agreeError');
        const isLoading = immRetailLoan.get('isFetchingDocumentsTermConditions');
        const errorLoading = immRetailLoan.get('errorDocumentsTermConditions');
        const agreeCheckbox = immRetailLoan.get('agree');

        const modalContent = (
            <React.Fragment>
                <ContractLoanPdfViewer
                    className="retail-loan-catalog-modal__viewer"
                    document={documentsTermConditions}
                    isLoading={isLoading}
                    isModal
                    errorLoading={errorLoading}
                    getDocuments={getTermConditionDocuments}
                    onPrint={this.handleOnPrintDocument}
                    onDownload={this.handleOnDownloadDocument}
                    validate={validate}
                    viewerHeight={viewerHeight}
                />
            </React.Fragment>
        );

        return (
            <OKModal
                content={modalContent}
                contentFooter={modalContentFooter}
                contentOverflow="auto"
                footerType="navigation"
                getSize={this.getSize}
                isOpen={showModal}
                onCloseCallback={() => onHandleToggleModal(TAGGING_CLOSE)}
                onPrimaryButtonClick={this.handleContinue}
                onSecondaryButtonClick={() => onHandleToggleModal(TAGGING_EXIT)}
                primaryButtonText={labels.continue}
                secondaryButtonText="common-exit"
                shouldCloseOnOverlayClick={true}
                size="large"
                title={title}
                primaryButtonDisabled={!agreeCheckbox}
            />
        );
    }

    buildModal() {
        const {
            immRetailLoan,
            item,
            labels,
            onHandleToggleModal,
            showModal,
        } = this.props;
        const isAddress = isRetailAddressDelivery(item.get('field_pickup_option'));
        const productDetail = this.buildProductDetail();

        const modalContent = (
            <div className="container-fluid">
                <div className="row">
                    <div className="retail-loan-catalog-modal__container-detail col-md-6 col-lg-6">
                        <RetailLoanImageGalleryContainer
                            immRetailLoan={immRetailLoan}
                            immItem={item}
                            listImages={item.get('field_product_images')}
                            isModal
                            mainImageWidth={MAIN_IMAGE_WIDTH_CATALOG_MODAL}
                            modalMoreInformation
                            zoomSide="modal"
                            zoom
                        />
                    </div>
                    <div className="retail-loan-catalog-modal__container-detail col-md-6 col-lg-6">
                        <div className="retail-loan-catalog-modal__detail-product">
                            <OKBoxTitle value={labels.title} />
                            <ul className="retail-loan-catalog-modal__detail-product-ul">
                                {productDetail}
                            </ul>
                        </div>
                        <div className="row">
                            <div className="retail-loan-catalog-modal__delivery-info col-md-12 col-lg-12">
                                <RetailDeliveryInfoBox isAddress={isAddress} labels={labels} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                isOpen={showModal}
                onCloseCallback={onHandleToggleModal}
                shouldCloseOnOverlayClick={true}
                size="extra-large"
            />
        );
    }

    buildProductDetail() {
        const { item } = this.props;
        const fieldProductsDetail = item.get('field_product_detail');

        return fieldProductsDetail.map((detail, idx) => {
            const spec = (<li key={idx}> {detail} </li>);
            return spec;
        })

    }

    getSize(height) {
        this.setState({ viewerHeight: height - MODAL_VIEWER_HEIGHT });
    }

    handleContinue() {
        const {
            immRetailLoan,
            item,
            setDeliveryDate,
            setPurpose,
            showInfoProduct,
            validateAgreeCheckBoxModal,
        } = this.props;

        const validCheckbox = immRetailLoan.get('agree');
        const showsInfoProduct = immRetailLoan.get('showInfoProduct');
        validateAgreeCheckBoxModal();

        const customDataEvent = buildEventsModal(
            LOAD_MODAL_TERMS_CONDITIONS,
            TAGGING_CONTINUE
        );
        const customData = {
            ...customDataEvent,
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "productPage",
        };
        recordLinkV2(customData);

        if (validCheckbox) {
            setPurpose({ purpose: item.get('nid') });
            setDeliveryDate({ deliveryDate: item.get('deliveryDate') });
            this.props.history.push(`/myprofile/loans-mortgages/contract-retail-loan/${item.get('nid')}`);
            if (showsInfoProduct) {
                showInfoProduct();
            }
        }
    }

    render() {
        return !this.props.hideActionSection ? this.buildPdfViewer() : this.buildModal();
    }
}

RetailLoanCatalogModalComponent.propTypes = {
    item: PropTypes.object.isRequired,
    showModal: PropTypes.bool,
    onHandleToggleModal: PropTypes.func.isRequired,
    setPurpose: PropTypes.func,
    setDeliveryDate: PropTypes.func,
    hideActionSection: PropTypes.bool,
    labels: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object,
    getTermConditionDocuments: PropTypes.func,
    validateAgreeCheckBoxModal: PropTypes.func,
    setAgree: PropTypes.func,
    onPrintDocument: PropTypes.func,
    onDownloadDocumentTermCondition: PropTypes.func,
    showInfoProduct: PropTypes.func,
    history: PropTypes.object.isRequired,
};

RetailLoanCatalogModalComponent.defaultProps = {
    hideActionSection: false
};

const RetailLoanCatalogModal = withRouter(RetailLoanCatalogModalComponent)

export { RetailLoanCatalogModal };
